import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AlertController } from '@ionic/angular';
import { contactRoles } from '@shared/constants/contact-roles';
import { Country } from '@shared/models/country';
import { ContactRole } from '@shared/types/contact-role';
import { GroupType } from '@shared/types/group-type';

@Component({
  selector: 'app-contact-item',
  templateUrl: './contact-item.component.html',
  styleUrl: './contact-item.component.scss',
  standalone: false,
})
export class ContactItemComponent implements OnInit, OnChanges {
  @Input() groupType: GroupType;
  @Input() contactForm: FormGroup;
  @Input() country: Country;
  @Input() contactIndex: number;
  @Input() errors: any;
  @Input() formSubmitted: boolean = false;
  @Output() editContact = new EventEmitter();
  @Output() resendEmailConfirmation = new EventEmitter();

  showEmailUnconfirmed = false;
  emailErrors: { [key: string]: string } = {};
  originalEmail: string;
  contactRoleDetailsByReference: Record<string, { icon: string; color: string }> = Object.fromEntries(
    contactRoles.map((contactRole) => [contactRole.reference, { icon: contactRole.icon, color: contactRole.color }]),
  );

  constructor(private alertController: AlertController) {}

  ngOnInit(): void {
    this.originalEmail = this.contactForm.controls['email'].value;
    this.errors?.contacts?.forEach((error: any) => {
      this.emailErrors[error.email] = error.message;
    });

    this.showEmailUnconfirmed =
      this.groupType !== 'customer' &&
      this.contactForm.controls['contact_roles'].value.some((contactRole: ContactRole) =>
        ['primary', 'accounts', 'strategic'].includes(contactRole),
      ) &&
      this.contactForm.controls['confirmed_email']?.value == false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['formSubmitted'] && changes['formSubmitted'].currentValue === true) {
      Object.keys(this.contactForm.controls).forEach((key) => {
        this.contactForm.get(key)?.markAsTouched();
      });
    }
  }

  removeRole(role: ContactRole, event: Event): void {
    event.stopPropagation();
    const contactRoles = this.contactForm.controls['contact_roles'];
    contactRoles.setValue(contactRoles.value.filter((existingRole: ContactRole) => existingRole !== role));
    contactRoles.markAsTouched();
    contactRoles.markAsDirty();
  }

  async presentResendEmailConfirmationPopover() {
    const alert = await this.alertController.create({
      header: 'Resend Email Confirmation?',
      subHeader: this.contactForm.controls['email'].value,
      message:
        'This contact is currently unverified, restricting access to certain features. To proceed, click below to resend the confirmation email',

      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          id: 'resend-email-cancel',
        },
        {
          text: 'Proceed',
          role: 'confirm',
          id: 'resend-email-confirm',
          handler: () => {
            this.resendEmailConfirmation.emit(this.contactForm.controls['email'].value);
          },
        },
      ],
    });
    await alert.present();
  }
}
